import React from 'react';
import css from './UserBadge.module.css';

const BadgeIcon = ({ level }) => {
  // Colors from the provided SVGs
  const colors = {
    gold: '#D4BB72',
    silver: '#C1C1C1',
    bronze: '#DF9A75',
  };
  const purple = '#2A113E';
  const badgeColor = colors[level] || colors.bronze;

  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 150 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={css.badgeIcon}
    >
      {/* Right ribbon */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.0096 120.524L103.33 151.071C103.831 151.96 105.112 151.914 105.548 150.993L113.834 133.466L136.535 141.082C137.544 141.177 138.238 140.092 137.737 139.202L115.15 97.9706C113.9 98.7572 113.008 99.734 112.267 101.11L107.218 110.481C103.218 117.906 95.1964 121.846 87.0096 120.524Z"
        fill={purple}
      />
      {/* Left ribbon */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.8711 118.808C53.7295 120.385 45.589 116.696 41.3594 109.399L36.0209 100.19C35.2369 98.8377 34.3162 97.8895 33.0413 97.1423L8.66365 139.919C8.18987 140.824 8.91749 141.887 9.9236 141.761L34.4505 132.529L43.2792 149.79C43.7436 150.697 45.0255 150.702 45.4982 149.798L61.8711 118.808Z"
        fill={purple}
      />
      {/* Outer rosette */}
      <path
        d="M100.929 121.694C94.868 119.398 88.6444 121.34 82.7614 126.057C79.3746 128.772 75.3727 127.876 72.3061 125.202C67.6964 121.18 62.6078 120.068 56.7489 121.489C51.239 122.826 47.313 120.87 45.1453 115.817C42.9428 110.685 39.1528 107.809 33.537 106.823C28.0957 105.869 25.0784 102.684 25.4371 97.0137C25.7849 91.5039 23.6823 87.1232 19.1039 83.8937C14.0201 80.3059 13.257 75.7595 16.1685 70.5681C18.8163 65.8466 18.5587 61.3225 16.0096 56.6563C13.2739 51.6493 14.0755 47.2392 18.9535 43.8487C23.787 40.49 25.7933 35.9048 25.4551 30.1965C25.153 25.1003 27.7094 21.9108 32.7571 21.0649C39.3189 19.9653 43.3641 16.2824 45.9866 10.4989C47.8461 6.3989 51.2763 4.87168 55.8498 6.00535C62.0517 7.54315 67.5869 6.63621 72.5588 2.28715C76.4427 -1.1115 80.8838 -0.50649 84.533 2.67953C89.2173 6.76779 94.3986 7.4891 100.153 6.04059C105.219 4.76595 108.881 6.44237 110.901 11.0346C113.303 16.4927 117.149 19.8067 123.273 20.8699C128.735 21.818 131.694 25.2624 131.246 30.8215C130.789 36.4617 133.087 40.631 137.638 43.8617C142.453 47.2803 143.379 51.6188 140.553 56.6762C137.825 61.5563 137.949 66.3529 140.628 71.1884C143.323 76.0496 142.476 80.2201 137.888 83.526C133.212 86.8953 130.813 91.1409 131.207 97.036C131.549 102.152 128.979 105.733 123.56 106.614C117.495 107.601 113.501 110.86 111.047 116.279C109.395 119.927 106.793 122.457 100.927 121.691L100.929 121.694Z"
        fill={badgeColor}
      />
      {/* Inner purple ring */}
      <path
        d="M97.3379 112.513C92.2389 110.582 87.0032 112.215 82.054 116.183C79.2047 118.467 75.8381 117.714 73.2582 115.464C69.3803 112.081 65.0994 111.145 60.1704 112.341C55.5351 113.466 52.2323 111.82 50.4087 107.569C48.5558 103.251 45.3674 100.832 40.643 100.003C36.0654 99.2003 33.527 96.521 33.8288 91.7504C34.1214 87.1153 32.3525 83.4298 28.5009 80.713C24.224 77.6947 23.5821 73.8699 26.0314 69.5025C28.2589 65.5305 28.0422 61.7245 25.8977 57.7989C23.5962 53.5868 24.2706 49.8766 28.3743 47.0244C32.4406 44.1988 34.1285 40.3414 33.8439 35.5392C33.5898 31.2519 35.7404 28.5686 39.9869 27.857C45.5071 26.932 48.9102 23.8336 51.1165 18.9682C52.6808 15.5189 55.5665 14.2341 59.4141 15.1879C64.6316 16.4816 69.2881 15.7186 73.4709 12.0599C76.7383 9.20067 80.4744 9.70965 83.5444 12.3899C87.4851 15.8293 91.844 16.4361 96.6849 15.2175C100.947 14.1452 104.028 15.5555 105.727 19.4188C107.748 24.0105 110.984 26.7986 116.135 27.693C120.73 28.4905 123.22 31.3883 122.842 36.065C122.459 40.8099 124.391 44.3174 128.22 47.0352C132.271 49.9112 133.049 53.5611 130.672 57.8157C128.378 61.9212 128.482 65.9565 130.736 70.0244C133.003 74.114 132.29 77.6225 128.43 80.4036C124.497 83.2381 122.479 86.8099 122.81 91.7692C123.097 96.0733 120.936 99.0857 116.376 99.8269C111.274 100.657 107.915 103.399 105.85 107.958C104.46 111.026 102.271 113.155 97.3359 112.511L97.3379 112.513Z"
        fill={purple}
      />
      {/* Inner colored circle */}
      <path
        d="M78.7382 19.2593C103.094 19.4551 123.013 39.6717 122.898 64.0794C122.783 88.6321 102.44 108.617 77.7367 108.445C53.1178 108.273 33.4194 87.9828 33.7127 63.0943C33.9999 38.6775 54.1488 19.0615 78.7382 19.2593Z"
        fill={badgeColor}
      />
      {/* Star */}
      <path
        d="M103.509 57.9507C103.176 56.9246 102.265 56.1981 101.193 56.101L86.5643 54.773L80.7831 41.2378C80.3562 40.2434 79.385 39.6016 78.304 39.6016C77.223 39.6016 76.2513 40.2434 75.8272 41.2378L70.0459 54.773L55.415 56.101C54.3425 56.2 53.4343 56.9265 53.0987 57.9507C52.765 58.9768 53.0732 60.1023 53.8843 60.8137L64.9424 70.51L61.6819 84.8703C61.4434 85.9262 61.8532 87.018 62.7293 87.6513C63.2002 87.9935 63.7535 88.1644 64.3087 88.1644C64.7858 88.1644 65.2633 88.0376 65.6897 87.7824L78.304 80.24L90.9159 87.7824C91.8411 88.3353 93.0045 88.2846 93.8786 87.6513C94.7547 87.018 95.1646 85.9262 94.926 84.8703L91.6656 70.51L102.724 60.8137C103.534 60.1023 103.843 58.9791 103.509 57.9507Z"
        fill={purple}
      />
    </svg>
  );
};

const UserBadge = ({ badge, size = 'small' }) => {
  if (!badge) return null;
  const { name, level = 'bronze' } = badge;

  return (
    <span className={`${css.badge} ${css[level]} ${css[size]}`} title={name}>
      <BadgeIcon level={level} />
      <span className={css.badgeName}>{name}</span>
    </span>
  );
};

export const UserBadgeList = ({ badges = [], size = 'small' }) => {
  if (!badges || badges.length === 0) return null;
  
  // Show only the most recent badge (first one since sorted by earnedAt desc)
  const mostRecentBadge = badges[0];

  return <UserBadge badge={mostRecentBadge} size={size} />;
};

// Component for displaying all badges on profile page
export const ProfileBadges = ({ badges = [], loading = false, error = null }) => {
  if (loading) {
    return <div className={css.badgesLoading}>Loading badges...</div>;
  }

  if (error) {
    return null;
  }

  if (!badges || badges.length === 0) {
    return null;
  }

  return (
    <div className={css.profileBadgesContainer}>
      <div className={css.badgeList}>
        {badges.map((badge, index) => (
          <UserBadge key={badge.badgeId || index} badge={badge} size="small" />
        ))}
      </div>
    </div>
  );
};

export default UserBadge;
